// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"PartnershipCard_subtitle__2m7Or","partnershipCardContentContainer":"PartnershipCard_partnershipCardContentContainer__2KOgi"};